import script from "./SearchPageSearchBarDropdownResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchBarDropdownResult.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchBarDropdownResult.vue?vue&type=style&index=0&id=e6ae6b1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6ae6b1a"]])

export default __exports__